<template>
  <div>
    <a-row>
      <a-col :span="6">
        <a-descriptions :column="1" class="simiot-descriptions">
          <a-descriptions-item label="入库批次">
            {{ batchOperationRecordInfo.operation_no }}
          </a-descriptions-item>
          <a-descriptions-item label="入库时间">
            {{ batchOperationRecordInfo.created_at }}
          </a-descriptions-item>
          <a-descriptions-item label="入库人">
            {{ batchOperationRecordInfo.operator_name }}
          </a-descriptions-item>
          <a-descriptions-item label="入库总数">
            {{ batchOperationRecordInfo.operation_count }}
          </a-descriptions-item>
          <a-descriptions-item label="入库成功数">
            {{ batchOperationRecordInfo.success_count }}
          </a-descriptions-item>
          <a-descriptions-item label="入库失败数">
            {{ batchOperationRecordInfo.failure_count }}
          </a-descriptions-item>
          <a-descriptions-item label="出库数">
            {{ batchOperationRecordInfo.allocated_count }}
          </a-descriptions-item>
        </a-descriptions>
      </a-col>

      <a-col :span="6">
        <a-descriptions :column="1" class="simiot-descriptions simiot-descriptions-max-6">
          <a-descriptions-item label="采购日期">
            {{ batchOperationRecordInfo.purchase_date }}
          </a-descriptions-item>
          <a-descriptions-item label="采购批次">
            {{ batchOperationRecordInfo.purchase_batch }}
          </a-descriptions-item>
          <a-descriptions-item label="供应商">
            {{ batchOperationRecordInfo.module_supplier_name }}
          </a-descriptions-item>
          <a-descriptions-item label="采购主体">
            {{ batchOperationRecordInfo.contracting_party_name }}
          </a-descriptions-item>
        </a-descriptions>
      </a-col>

      <a-col :span="6">
        <a-descriptions :column="1" class="simiot-descriptions simiot-descriptions-max-6">
          <a-descriptions-item label="模组厂商">
            {{ batchOperationRecordInfo.module_producer_name }}
          </a-descriptions-item>
          <a-descriptions-item label="模组型号">
            {{ batchOperationRecordInfo.module_model_name }}
          </a-descriptions-item>
          <a-descriptions-item label="固件版本">
            {{ batchOperationRecordInfo.firmware_version }}
          </a-descriptions-item>
          <a-descriptions-item label="税点">
            {{ batchOperationRecordInfo.invoice_rate_name }}
          </a-descriptions-item>
        </a-descriptions>
      </a-col>

      <a-col :span="6">
        <a-descriptions :column="1" class="simiot-descriptions simiot-descriptions-max-7">
          <a-descriptions-item label="单价">
            {{ batchOperationRecordInfo.unit_price }}
          </a-descriptions-item>
          <a-descriptions-item label="总价">
            {{ batchOperationRecordInfo.total_price }}
          </a-descriptions-item>
          <a-descriptions-item label="重跑次数">
            {{ batchOperationRecordInfo.run_times }}
          </a-descriptions-item>
          <a-descriptions-item label="备注">
            <span class="batch-operation-record-info">
              {{ batchOperationRecordInfo.remark }}
            </span>
          </a-descriptions-item>
        </a-descriptions>
      </a-col>
    </a-row>

    <a-row>
      <a-col>
        <span>
          注：执行批量模组入库操作时，如果有一个模组入库失败，不会影响其他模组的入库，但本次入库的操作结果为失败。
        </span>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  name: 'BatchOperationRecordModulesImportInfo',
  props: {
    batchOperationRecordInfo: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="less" scoped>
.batch-operation-record-info {
  word-break: break-all;
}
</style>
